import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CryptoOnboardingPageBase } from '@zero/self-service/feature-crypto-onboarding/base';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { UserMessagesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { AuthService } from '@zero/shared/util-web-app-services';
import { commonRoutes } from 'constants/web-app-constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'self-service-crypto-onboarding-page',
  templateUrl: './crypto-onboarding-page.component.html',
  imports: [LoadingIndicatorDirective, RouterLink, UserMessagesComponent, AsyncPipe, ButtonComponent],
})
export class CryptoOnboardingPageComponent extends CryptoOnboardingPageBase implements OnInit, OnDestroy {
  public readonly commonRoutes = commonRoutes;
  #isLoggedInSubscription = new Subscription();

  readonly #authService = inject(AuthService);

  public ngOnInit(): void {
    this.init();
    this.#subscribeToLoggedInState();
  }

  ngOnDestroy(): void {
    this.#isLoggedInSubscription.unsubscribe();
  }

  #subscribeToLoggedInState() {
    if (this.#isLoggedInSubscription.closed) {
      this.#isLoggedInSubscription = new Subscription();
    }

    this.#isLoggedInSubscription = this.#authService.isLoggedIn$().subscribe((loggedIn) => {
      if (!loggedIn) {
        this.cryptoOnboardingFacade.resetAddressConfirmationDate();
      }
    });
  }
}
